// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3wSLS","content":"styles_content__1CnbW","selectAll":"styles_selectAll__1KQ6p"};